import React, { useState, useEffect, useRef } from 'react';
import AlertMessage from "../../AlertMessage";
import loadingspinner from '../../assets/images/loading2.gif'

function PresentyReport() {
  const [classValue, setClassValue] = useState('');
  const [divisionValue, setDivisionValue] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [allDates, setAllDates] = useState([]); // Store all dates for table headers
  const udiseNumber = localStorage.getItem("udiseNumber");

  const currentMonth = new Date().toISOString().slice(0, 7);
  const [month, setMonth] = React.useState(currentMonth);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
    const [savingData, setSavingData] = useState(false);

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage(""); 
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  const printRef = useRef(null);

  useEffect(() => {
    fetchStudentData();
  }, [classValue, divisionValue]);

  
  const [classes, setClasses] = useState([]); 
  const [divisions, setDivisions] = useState({}); 

  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      console.log("storedDivClasses",storedDivClasses);
      
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);
        
        const classList = [];
        const divisionList = {};
  
        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            // Class without divisions
            classList.push(className);
            divisionList[className] = []; // Initialize with an empty array
          } else if (typeof value === 'object') {
            // Class with divisions
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
          }
        }
        setClasses(classList);
        setDivisions(divisionList); // Set the divisionList as the state
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };
  
  useEffect(() => {
    fetchClassDivData();
  }, [udiseNumber]);


  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
      
      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
        reject('Error opening IndexedDB');
      };
      
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
      
      // If the database exists and needs to be downgraded
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        const oldVersion = event.oldVersion;
        
        // Delete existing object stores
        for (const objectStoreName of db.objectStoreNames) {
          db.deleteObjectStore(objectStoreName);
        }
        
        // Create new object stores with the correct version
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('attendance')) {
          db.createObjectStore('attendance', { keyPath: 'id' });
        }
      };
      
      // If t?he database exists and needs to be downgraded
      request.onblocked = (event) => {
        const db = event.target.result;
        const oldVersion = event.oldVersion;
        
        // Delete existing object stores
        for (const objectStoreName of db.objectStoreNames) {
          db.deleteObjectStore(objectStoreName);
        }
        
        // Create new object stores with the correct version
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('attendance')) {
          db.createObjectStore('attendance', { keyPath: 'id' });
        }
      };
    });
  };
  

  const fetchStudentData = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();
  
      allRecords.onsuccess = (event) => {
        const data = event.target.result;
  
        // Filter to get only active students
        const filteredData = Object.keys(data)
          .filter(key => data[key] !== null && (data[key].isActive === true || data[key].isActive === undefined)) // Include active students or those without isActive
          .map(key => ({ srNo: key, ...data[key] }));
  
        // Filter students based on selected class
        const studentsInClass = filteredData.filter(student => student.currentClass === classValue);
  
        // If a division is selected, filter by division as well
        const studentsInClassAndDivision = divisionValue 
          ? studentsInClass.filter(student => student.division === divisionValue)
          : studentsInClass; // If no division is selected, include all students in the class
  
        setStudentData(studentsInClassAndDivision);
      };
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };


 const [allDivisions, setAllDivisions] = useState([]);
 const handleClassChange = (e) => {
  const selectedClass = e.target.value;
  setClassValue(selectedClass);

  // Update divisions based on selected class
  if (selectedClass && divisions[selectedClass]) {
    const filteredDivisions = divisions[selectedClass].filter(div => div);
    setAllDivisions(filteredDivisions);
  } else {
    setAllDivisions([]);
  }
};

const handleDivisionChange = (e) => {
  setDivisionValue(e.target.value);
};

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
  };

  

const getAllDatesForMonth = (month) => {
  const date = new Date(month);
  const year = date.getFullYear();
  const monthIndex = date.getMonth();
  const lastDay = new Date(year, monthIndex + 1, 0); // Get the last day of the month

  const allDates = [];
 for (let day = 1; day <= lastDay.getDate(); day++) {
    allDates.push(day); // No padding, just day (1, 2, 3,...)
  }

  return allDates;
};

const handleGenerateReport = async () => {
  if (!classValue || !month) {
    setAlertMessage('Please select class and month');
    return;
  }
  setSavingData(true);
  const selectedMonth = new Date(month);
  const year = selectedMonth.getFullYear();
  const monthName = selectedMonth.toLocaleString('default', { month: 'short' });
  
  const allDates = getAllDatesForMonth(month); // Get all dates for the month

  try {
    const attendancePromises = studentData
      .filter((student) => student.currentClass === classValue) // Include all students in the selected class
      .filter((student) => !divisionValue || student.division === divisionValue) // Include students if no division is selected
      .map(async (student) => {
        const db = await openIndexedDB();
        const transaction = db.transaction(['attendance'], 'readonly');
        const objectStore = transaction.objectStore('attendance');
        const allRecords = objectStore.getAll();

        return new Promise((resolve, reject) => {
          allRecords.onsuccess = (event) => {
            const data = event.target.result;
            
            const record = data.find(item => item.srNo == student.serialNo);

            if (record) {
              const attendanceRecord = record;
              const attendance = {};

              const presentyData = attendanceRecord.Presenty.Presenty;
              allDates.forEach((date) => {
                const attendanceDate = `${year}-${monthName}-${date}`;
               if (
                  presentyData?.[year]?.[monthName]?.[date] &&
                  presentyData[year][monthName][date]?.present !== undefined
                ) {
                  attendance[date] = presentyData[year][monthName][date];
                } else {
                  attendance[date] = null; // ✅ Mark as null to indicate no data
                }

              });





              resolve({
                religion: student.religion,
                registerNo: student.registerNo,
                mobileNo: student.mobileNo,
                dob: student.dob,
                rollNo: student.rollNo,
                srNo: student.serialNo,
                caste: student.caste || '-', // Add a default value if caste is undefined
                stdName: student.stdName,
                stdMother: student.stdMother,
                stdFather: student.stdFather,
                stdSurname: student.stdSurname,
                attendance,
              });
            } else {
              resolve({
                religion: student.religion,
                registerNo: student.registerNo,
                mobileNo: student.mobileNo,
                dob: student.dob,
                rollNo: student.rollNo,
                srNo: student.serialNo,
                caste: student.caste || '-', // Add a default value if caste is undefined
                stdName: student.stdName,
                stdMother: student.stdMother,
                stdFather: student.stdFather,
                stdSurname: student.stdSurname,
                attendance: allDates.reduce((acc, date) => ({ ...acc, [date]: { present: 'absent' } }), {}),
              });
            }
          };

          allRecords.onerror = (event) => {
            reject(event.target.error);
          };
        });
      });

    const fetchedAttendance = await Promise.all(attendancePromises);

    // Sort attendance data by rollNo
    fetchedAttendance.sort((a, b) => a.rollNo - b.rollNo);

    setAttendanceData(fetchedAttendance);
    setAllDates(allDates);
  } catch (error) {
    console.error('Error fetching attendance data:', error);
    setAlertMessage('Mark Attendance and Please try again.');
  } finally {
    setSavingData(false);
  }
};

// ?

  // Helper function to check if all students are absent on a specific date
  const isDateAllAbsent = (date) => {
    return attendanceData.every(student => student.attendance[date]?.present !== 'present');
  };

  attendanceData.map((item, index) => {
  console.log(`Key: ${index + 1}`);
  console.log(item);
});
  
  

    const [schoolData, setSchoolData] = useState(null); 
    const [logoURL, setLogoURL] = useState(null); 

    const fetchSchoolData = async () => {
      if (udiseNumber) {
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['schoolData'], 'readonly');
          const objectStore = transaction.objectStore('schoolData');
          const request = objectStore.get(udiseNumber);
    
          request.onsuccess = (event) => {
            const data = event.target.result;
            if (data) {
              setSchoolData(data);
              setLogoURL(data.schoolLogo); // Set the logo URL
            }
          };
    
          request.onerror = (event) => {
            console.error("Error fetching school data:", event.target.error);
          };
        } catch (error) {
          console.error('Error fetching school data:', error);
        }
      }
    };
  
    useEffect(() => {
      fetchSchoolData ();
  }, [udiseNumber]);

   const handlePrint = () => {
      if (!schoolData) {
        console.error("School data is not loaded yet.");
        return;
      }
  
        const printContents = `
          <style>
           body {
    margin: 0;
    padding: 0;
  }
.table {
  width: 100%;
  border-collapse: collapse;
}

@page {
  size: A4 portrait; /* or size: 210mm 297mm; */
  margin: 10mm; /* Adjust margins as needed */
}

.table th, .table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
  font-size: 12px
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
    font-size: 12px
}

.table thead th {
  vertical-align: middle;
}

.table tbody td {
  vertical-align: middle;
}

.text-center {
  text-align: center;
}
            .school-header {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-bottom: 20px;
              padding: 10px;
              border: 1px solid black; /* Add border to the header */
            }
            .school-header img {
              max-height: 70px; /* Adjust as needed */
              margin-right: 15px; /* Spacing between logo and school name */
            }
            .school-header h1 {
              font-size: 24px; /* Increased font size for school name */
              margin: 0;
              text-align: left; /* Align text to the left */
              flex: 1; /* Take up remaining space */
              text-overflow: ellipsis; /* Add ellipsis if text overflows */
              white-space: nowrap; /* Prevent text from wrapping to next line */
            }
            .school-header h1.multi-line {
              text-align: center; /* Center text if it wraps to next line */
              white-space: normal; /* Allow text to wrap to next line */
            }
            .school-header-container {
              margin-bottom: 20px;
            }

            .prevnextbtn{
              display: none;
            }
          </style>
          
          <div>
            ${printRef.current.innerHTML}
          </div>
        `;
    
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
    
        window.print();
    
        document.body.innerHTML = originalContents;
        window.location.reload(); // Reload to restore original content
      };
    
      const getStudentCounts = () => {
        // Filter students based on selected class
        const filteredStudents = studentData.filter(student => 
          student.currentClass === classValue // Include all students in the selected class
        );
      
        // If a division is selected, further filter by division
        const studentsInDivision = divisionValue 
          ? filteredStudents.filter(student => student.division === divisionValue)
          : filteredStudents; // If no division is selected, include all students in the class
      
        const totalStudents = studentsInDivision.length;
        const totalBoys = studentsInDivision.filter(student => student.gender === 'male').length;
        const totalGirls = studentsInDivision.filter(student => student.gender === 'female').length;
      
        const casteCounts = {};
        studentsInDivision.forEach(student => {
          if (student.caste) { // Check if student has a caste property
            const caste = student.caste;
            if (!casteCounts[caste]) {
              casteCounts[caste] = { boys: 0, girls: 0 };
            }
            if (student.gender === 'male') {
              casteCounts[caste].boys += 1;
            } else if (student.gender === 'female') {
              casteCounts[caste].girls += 1;
            }
          }
        });
      
        return { totalStudents, totalBoys, totalGirls, casteCounts };
      };

const { totalStudents, totalBoys, totalGirls, casteCounts } = getStudentCounts();

// const [currentPage, setCurrentPage] = useState(1);
// const [studentsPerPage, setStudentsPerPage] = useState(38);
// const [castesPerPage, setCastePerPage] = useState(9);
// const [currentReportIndex, setCurrentReportIndex] = useState(0);


// Keep only these pagination states
const [currentAttendancePage, setCurrentAttendancePage] = useState(1);
const [currentCastePage, setCurrentCastePage] = useState(1);
const studentsPerPage = 38;
const castesPerPage = 9;

// Calculate paginated data
const paginatedCastes = Object.keys(casteCounts).slice(
  (currentCastePage - 1) * castesPerPage,
  currentCastePage * castesPerPage
);

const paginatedStudents = attendanceData.slice(
  (currentAttendancePage - 1) * studentsPerPage,
  currentAttendancePage * studentsPerPage
);

// Calculate total pages
const totalAttendancePages = Math.ceil(attendanceData.length / studentsPerPage);
const totalCastePages = Math.ceil(Object.keys(casteCounts).length / castesPerPage);

// const paginatedStudents = attendanceData.slice(
//   (currentPage - 1) * studentsPerPage,
//   currentPage * studentsPerPage
// );

  return (
    <div  className='main-content-of-page' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '50px'}}>
      <AlertMessage message={alertMessage} show={showAlert}/>

      {savingData && <img width={'80px'} className="registerLoading" src={loadingspinner} style={{top:'50%', left:'50%'}} />}

      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', width: '1500px' }}>
        <div className="p-4 bg-light rounded shadow">
          <h3 style={{color:'rgb(3, 54, 94)', fontWeight:'600' }} className="text-center mb-4">{language=== "English" ? "Attendance Report" : "उपस्थिती अहवाल"}</h3>
          <div style={{ margin: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', backgroundColor: '#f9f9f9' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>
              {/* Class Selection */}
              <div style={{ flex: '1', marginBottom: '15px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>{language==="English" ? "Select Class :" : "वर्ग निवडा:"}</label>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  style={{ width: '100%', padding: '8px', border: '1px solid #007bff', borderRadius: '5px', backgroundColor: '#fff' }}
                >
                  <option value=""> {language==="English" ? "Select Class" : "वर्ग निवडा"}</option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </div>

              {/* Division Selection */}
              <div style={{ flex: '1', marginBottom: '15px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>{language==="English" ? "Division :" : "तुकडी:"}</label>
                <select
                  id="division"
                  value={divisionValue}
                  onChange={handleDivisionChange}
                  style={{ width: '100%', padding: '8px', border: '1px solid #007bff', borderRadius: '5px', backgroundColor: '#fff' }}
                >
                  <option value=""> {language==="English" ? "Select Division" : "तुकडी निवडा"}</option>
                  {allDivisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </div>

              {/* Month Selection */}
              <div style={{ flex: '1', marginBottom: '15px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>{language==="English" ? "Select Month :" : "महिना निवडा:"}</label>
                <input
                  type="month"
                  value={month}
                  onChange={handleMonthChange}
                  style={{ width: '100%', padding: '8px', border: '1px solid #007bff', borderRadius: '5px', backgroundColor: '#fff' }}
                />
              </div>
            </div>

            <button
              className="btn btn-primary mb-4"
              onClick={handleGenerateReport}
              style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
              Generate Report
            </button>
          </div>

{/* second Page  */}
          {attendanceData.length > 0 && (
            <>
              <div ref={printRef}>

{/* First Page  */}
 <div
  style={{
    width: '207mm',
    height: '301mm',
    margin: 'auto',
    padding: '5mm',
    boxSizing: 'border-box',
    border: '1px solid #000',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    color: '#000',
  }}
>

<div style={{ textAlign: 'center', marginBottom: '8px', fontSize: '18px', fontWeight: 'bold' }}>
  {language === "English" ? "Fee, Attendance, and Study Monthly Report - Month: " : "फी, उपस्थिती, अभ्यास इत्यादीचे मासिक पत्रक - महिना : "} {month}
</div>
<div style={{ textAlign: 'center', marginBottom: '10px', fontSize: '16px' }}>
  <span>{language === "English" ? "Note: " : "सूचना: "}</span>{language === "English" ? "All records on this report should be correct and accurate." : "या पत्रकावरील सर्व नोंदी योग्य प्रकारे आणि अचूक कराव्यात."}
</div>
<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
  <span>{language === "English" ? "Class Teacher Name: " : "वर्गशिक्षकाचे नाव :- "} _ _ _ _ _ _ _ _ _ _ _  </span>
  <span>{language === "English" ? "Class: " : "वर्ग :- "} {classValue}</span>
  <span>{language === "English" ? "Division: " : "तुकडी :- "} {divisionValue}</span>
</div>
  {/* Table Section */}
  <table className="table table-bordered"
  style={{
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'center',
    fontSize: '12px',
    border: '1.5px solid #000',
  }}
>
  {/* Header */}
  <thead>
    <tr>
      <th style={{ border: '1.5px solid #000', padding: '10px 70px', backgroundColor: '#f0f0f0' }} rowSpan="2">
        {language === "English" ? "Student Type" : "विद्यार्थी प्रकार"}
      </th>
      <th rowSpan={2} style={{ border: '1.5px solid #000', padding: '8px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Fee Rate" : "फीचा दर"}
      </th>
      <th rowSpan={2} style={{ border: '1.5px solid #000', padding: '8px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "1st Day of Month" : "महिनाचा 1ला दिवस"}
      </th>
      <th colSpan="3" style={{ border: '1.5px solid #000', padding: '8px', textAlign: 'center', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Total Admission" : "दाखल संख्या"}
      </th>
      <th colSpan="3" style={{ border: '1.5px solid #000', padding: '8px', textAlign: 'center', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Reduced Number" : "कमी संख्या"}
      </th>
      <th rowSpan="2" style={{ border: '1.5px solid #000', padding: '10px 40px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "End of Month" : "महिन्याच्या शेवटच्या"}<br/>
        {language === "English" ? " Count" : " दिवशी संख्या"}

      </th>
    </tr>
    <tr>
      <th rowSpan={2} style={{ border: '1.5px solid #000', padding: '13px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "New" : "नवीन"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '13px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Passed" : "पास होऊन"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '13px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Girls" : "मुली"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '13px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Total" : "एकूण"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '13px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Boys" : "मुलं"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '13px', writingMode: 'vertical-rl', transform: 'rotate(180deg)', backgroundColor: '#f0f0f0' }}>
        {language === "English" ? "Girls" : "मुली"}
      </th>
    </tr>
  </thead>
  {/* Body */}
  <tbody>
  {[
    { english: "1) Full Fee Payers", marathi: "१) पूर्ण की देणारे" },
    { english: "2) EBC Discount", marathi: "२) ई.बी.सी. सवलत" },
    { english: "3) Government Employee Discount", marathi: "३) सरकारी नोकरसवलत" },
    { english: "4) BCEBC Discount", marathi: "४) बी.सी.ई.बी.सी. सवलत" },
    { english: "5) BC Discount", marathi: "५) बी.सी. सवलत" },
    { english: "6) Army Soldier Discount", marathi: "६) स्या, सैनिक सवलत" },
    { english: "7) Professor Teacher Discount", marathi: "०) प्रा. शिक्षक सवलत" },
    { english: "8) Ma. Teacher Discount", marathi: "८) मा.शिक्षक सवलत" },
    { english: "9) Special Discount Holder", marathi: "९) खास की सवलत धारक" },
    { english: "10) Soldier Children", marathi: "१०) जवान मुले" },
    { english: "11) Special Discount for Students", marathi: "११) विद्यार्थिनीसाठी खास सवलत" },
    { english: "12) Children of Ex-Servicemen", marathi: "१२) माजी सैनिकांची मुले" },
    { english: "Total", marathi: "एकण" },
  ].map((type, index) => (
    <tr key={index}>
      <td style={{ border: '1.5px solid #000', padding: '5px' }}>
        {language === "English" ? type.english : type.marathi}
      </td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '5px' }}></td>
      </tr>
    ))}
  </tbody>
</table>



<table className="table table-bordered"
  style={{
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'center',
    fontSize: '12px',
    border: '1.5px solid #000',
    borderBottom: 'none',
    borderTop: 'none',
  }}
>
  <thead>
    <tr>
      <th
        rowSpan="2"
        style={{
          border: '1.5px solid #000',
          backgroundColor: '#f0f0f0',
        }}
      >
        {language === "English" ? "Month End" : "महिना अखेरीस"}
      </th>
      <th
        colSpan="5"
        style={{
          textAlign: 'center',
          border: '1.5px solid #000',
          padding: '4px',
          backgroundColor: '#f0f0f0',
          borderTop: 'none',
        }}
      >
        {language === "English" ? "Backward Classes" : "मागासवर्गीय"}
      </th>
      <th
        rowSpan="2"
        style={{
          textAlign: 'center',
          border: '1.5px solid #000',
          padding: '4px',
          backgroundColor: '#f0f0f0',
          borderTop: 'none',
        }}
      >
        {language === "English" ? "Non" : "बिगरमागास"}
        {language === "English" ? "Backward" : ""}

      </th>
      <th
        rowSpan="2"
        style={{
          border: '1.5px solid #000',
          padding: '4px 20px',
          backgroundColor: '#f0f0f0',
          borderTop: 'none',
        }}
      >
        {language === "English" ? "Total" : "एकूण"}
      </th>
      <th
        rowSpan="2"
        style={{
          border: '1.5px solid #000',
          padding: '4px 20px',
          backgroundColor: '#f0f0f0',
          borderTop: 'none',
        }}
      >
        {language === "English" ? "Average" : "सरासरी उपस्थिती"}<br/>
        {language === "English" ? "Attendance" : ""}

      </th>
      <th
        rowSpan="2"
        style={{
          border: '1.5px solid #000',
          padding: '4px 20px',
          backgroundColor: '#f0f0f0',
          borderTop: 'none',
        }}
      >
        {language === "English" ? "Average" : "सरासरी वय"} <br/>
        {language === "English" ? "Age" : ""}

      </th>
    </tr>
    <tr>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}></th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "SC" : "एस.सी."}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "ST" : "एस.टी."}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "NT" : "एन.टी."}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "OBC" : "ओ.बी.सी."}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td rowSpan="3" style={{ border: '1.5px solid #000', backgroundColor: '#f0f0f0', textAlign: "center" }}>
        {language === "English" ? "Student Classification" : "विद्यार्थी वर्गीकरण"}
      </td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "Boys" : "मुलं"}
      </td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
    </tr>
    <tr>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "Girls" : "मुली"}
      </td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
    </tr>
    <tr>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "Total" : "एकूण"}
      </td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
    </tr>
  </tbody>
</table>


  <table className="table table-bordered"
    style={{
      width: '100%',
      borderCollapse: 'collapse',
      textAlign: 'center',
      fontSize: '12px',
      border: '1.5px solid #000',
    }}
  >
    <thead>
    <tr>
      <th
        rowSpan="2"
        style={{
          border: '1.5px solid #000',
          backgroundColor: '#f0f0f0',
        }}
      >
        {language === "English" ? "Fee Paid in the Office" : "ऑफिसमध्ये भरणा केलेली फी रक्कम"}
      </th>
      <th
        colSpan="2"
        style={{ border: '1.5px solid #000', padding: '4px', backgroundColor: '#f0f0f0' }}
      >
        {language === "English" ? "Tuition Fee" : "ट्यूशन फी"}
      </th>

      <th
        colSpan="2"
        style={{ border: '1.5px solid #000', padding: '4px', backgroundColor: '#f0f0f0' }}
      >
        {language === "English" ? "Term Fee" : "टर्म फी"}
      </th>
      <th
        colSpan="2"
        style={{ border: '1.5px solid #000', padding: '4px', backgroundColor: '#f0f0f0' }}
      >
        {language === "English" ? "Admission Fee" : "प्रवेश फी"}
      </th>
      <th
        colSpan="2"
        style={{ border: '1.5px solid #000', padding: '4px 30px', backgroundColor: '#f0f0f0' }}
      >
        {language === "English" ? "Total" : "एकुन"}
      </th>
      <th
        rowSpan="2"
        style={{ border: '1.5px solid #000', padding: '4px 40px', backgroundColor: '#f0f0f0' }}
      >
        {language === "English" ? "Receipt " : "पोच तारीख"}<br/>
        {language === "English" ? " Date" : ""}

      </th>
      <th
        rowSpan="2"
        style={{ border: '1.5px solid #000', padding: '4px', backgroundColor: '#f0f0f0' }}
      >
        {language === "English" ? "Receiver's" : "घेणार्‍याची सही"}<br/>
        {language === "English" ? " Sign" : ""}

      </th>
    </tr>

      <tr>
      <th style={{ border: '1.5px solid #000', padding: '2px' }}>
        {language === "English" ? "Rupees" : "रुपये"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '2px' }}>
        {language === "English" ? ".00" : "पैसे"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "Rupees" : "रुपये"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? ".00" : "पैसे"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "Rupees" : "रुपये"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? ".00" : "पैसे"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? "Rupees" : "रुपये"}
      </th>
      <th style={{ border: '1.5px solid #000', padding: '4px' }}>
        {language === "English" ? ".00" : "पैसे"}
      </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}>{language === "English" ? "A) Previous Dues" : "अ) मागील येणे बाकी"}</td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td rowSpan={3} style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      </tr>
      <tr>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}>{language === "English" ? "B) Current Deposit" : "ब) चालू जमा"}</td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      </tr>
      <tr>
        <td style={{ border: '1.5px solid #000', padding: '4px' , textAlign:"right"}}>{language === "English" ? "Total A B" : " एकुन अ ब"}</td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      </tr>
      <tr>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}>{language === "English" ? "c) Deposit of fees" : "क) फी जमा"}</td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td colSpan={2} rowSpan={2} style={{ border: '1.5px solid #000', padding: '4px', textAlign:'left' }}> {language === "English" ? "Total deposits in the month" : "महिन्यातील एकुन जमा रक्कम"}<br/> {language === "English" ? "Average:-" : "सरासरी:-"}</td>
      </tr>
      <tr>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}>{language === "English" ? "d) Learning" : "ड) अध्याप येणे"}</td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
        <td style={{ border: '1.5px solid #000', padding: '4px' }}></td>
      </tr>
    </tbody>
  </table>
  <div style={{ marginTop: '20px', fontSize: '14px' }}>
  <div>
    {language === "English" ? "Remaining Dues for Next Month Rs. _ _ _ _ _ _ _" : "पुढील महिन्यासाठी घेतलेली बाकी रु. _ _ _ _ _ _ _ _"}
  </div>
  <div>
    {language === "English" ? "Fee for Registering Students Without Fee Rs. _ _ _ _ _ _" : "फी न देता नावे कमी केलेल्या विद्यार्थ्यांची रजिस्टरमध्ये नोंद करणेची फी रु. _ _ _ _ _ _"}
  </div>
  <div style={{}}>
    {language === "English" ? "Total Rs. _ _ _ _ _ _ _" : "एकूण रु. _ _ _ _ _ _ _"}
  </div>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '50px'
  }}>
    <span>{language === "English" ? "Class Teacher" : "वर्गशिक्षक"}</span>
    <span>{language === "English" ? "Supervisor" : "पर्यवेक्षक"}</span>
    <span>{language === "English" ? "Principal" : "मुख्याध्यापक"}</span>
  </div>
</div>
</div>


<div
  style={{
    width: '207mm',
    height: '301mm',
    margin: 'auto',
    padding: '2mm',
    boxSizing: 'border-box',
    border: '1.5px solid #000',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    color: '#000',
    marginTop: '30px',
  }}
>
  <table
    className="table table-bordered table-hover table-striped"
    style={{ fontSize: '12px' }}
  >
    <thead className="thead-dark">
      <tr>
        <th scope="col" colSpan="36" style={{ color: 'black' }}>
          {language === "English" ? "Attendance Sheet of" : "उपस्थिती पत्रक"} {month}
        </th>
      </tr>
      <tr>

      <th scope="col" style={{ width: '15px', padding: '1.5px', color: 'black' }} rowSpan="2">
          {language === "English" ? "Roll" : "रोल"}<br/>
          {language === "English" ? "No" : " क्र"}

        </th>

        <th scope="col" rowSpan="2" style={{ width: '10px', padding: '4px', color: 'black' }}>
          {language === "English" ? "Religion" : "धर्म"}
        </th>


        <th scope="col" rowSpan="2" style={{ width: '10px', padding: '4px', color: 'black' }}>
          {language === "English" ? "Caste" : "जात"}
        </th>
 <th scope="col" rowSpan="2" style={{ width: '10px', padding: '4px', color: 'black' }}>
          {language === "English" ? "Reg." : "रजि."} <br />
          {language === "English" ? "No" : " क्र"}
        </th>
<th scope="col" rowSpan="2" style={{ width: '10px', padding: '4px', color: 'black' }}>
          
          {language === "English" ? "Mother's" : "आईचे"} <br />
          {language === "English" ? "Name" : "नाव"}
        </th>
         <th scope="col" rowSpan="2" style={{ width: '10px', padding: '4px', color: 'black' }}>
          {language === "English" ? "Mobile No" : "मोबाईल क्र"}
        </th>

        <th scope="col" rowSpan="2" style={{ width: '10px', padding: '4px', color: 'black' }}>
          {language === "English" ? "DOB" : "जन्मतारीख"}
        </th>
        
       
        
       
        <th
          scope="col"
          style={{ padding: '4px', textAlign: 'center', color: 'black' }}
          rowSpan="2"
        >
        
          {language === "English" ? "Name" : "नाव"}
        </th>



        
      </tr>
    </thead>
    <tbody>
      {paginatedStudents.map((student) => (
        <tr key={student.srNo}>
           <td style={{ width: '15px', padding: '4px' }}>{student.rollNo}</td>
<td style={{ width: '10px', padding: '1.5px' }}>{student.religion}</td>
          <td style={{ width: '10px', padding: '1.5px' }}>{student.caste}</td>
 <td style={{ width: '10px', padding: '1.5px' }}>{student.registerNo}</td>
<td style={{ width: '10px', padding: '1.5px' }}>{student.stdMother}</td>
         <td style={{ width: '10px', padding: '1.5px' }}>{student.mobileNo}</td>

          <td style={{ width: '10px', padding: '1.5px' }}>{student.dob}</td>
          
          <td style={{ padding: '4px' }}>
            {student.stdName} {student.stdFather} {student.stdSurname}
          </td>
       
        </tr>
      ))}
    </tbody>
  </table>
</div>
  {/* <div className='prevnextbtn'>
    <button
      onClick={() => setCurrentPage(currentPage - 1)}
      disabled={currentPage === 1}
    >
      Previous
    </button>
    <button style={{marginLeft:'10px'}}
        onClick={() => {
          if (currentPage === Math.ceil(attendanceData.length / studentsPerPage)) {
            setCurrentReportIndex(currentReportIndex + 1);
          } else {
            setCurrentPage(currentPage + 1);
          }
        }}
        disabled={currentPage === Math.ceil(attendanceData.length / studentsPerPage)}
      >
        Next
      </button>
  </div> */}




 <div
  style={{
    width: '207mm',
    height: '301mm',
    margin: 'auto',
    padding: '2mm',
    boxSizing: 'border-box',
    border: '1.5px solid #000',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    color: '#000',
    marginTop:'30px'
  }}
>
<table className="table table-bordered table-hover table-striped" style={{ fontSize: '12px' }}>
              <thead className="thead-dark">
  <tr>
  <th scope="col" colSpan="36" style={{ color:'black'}}> {language === "English" ? "Attendance Sheet of :" : "उपस्थिती पत्रक :" } {month} </th>
  </tr>
  <tr>
  <th scope="col" style={{ width: '15px', padding: '1.5px' , color:'black'}} rowSpan="2">  {language === "English" ? "Roll" : "रोल"}<br/>
  {language === "English" ? "No" : " क्र"}</th>
    {allDates
      .sort((a, b) => Number(a) - Number(b))
      .map((date, index) => (
        <th  
          key={index}
          scope="col"
          style={{
            width: '60px', // Reduced width by half
            padding: '4px', // Reduced padding
            backgroundColor: isDateAllAbsent(date) ? 'red' : 'transparent',
            color: isDateAllAbsent(date) ? 'black' : 'inherit',
          }}
        >
          {date}
        </th>
         ))}    
    <th scope="col" style={{ padding: '1px', width: '15px' , color:'black'}}>{language === "English" ? "Total" : "एकूण"}</th>
    <th scope="col" style={{ padding: '1px', width: '15px' , color:'black'}}>{language === "English" ? "Sign" : "शेरा"}</th>

  </tr>
</thead>


{/* <td
  key={index}
  style={{
    width: '50px',
    padding: '4px',
    backgroundColor: 
      student.attendance[date]?.present === 'absent' ? '#FF8A8A' :
      student.attendance[date]?.present == null ? 'rgb(239 196 0 / 20%)' : 
      'transparent',
  }}
>
  {student.attendance[date]?.present === 'present' ? 'P' :
   student.attendance[date]?.present === 'absent' ? 'A' :
   'H'}
</td> */}


<tbody>
  {paginatedStudents.map((student) => {
    const totalPresent = allDates.reduce((total, date) => (
      student.attendance[date]?.present === 'present' ? total + 1 : total
    ), 0);
    return (
      <tr key={student.srNo}>
        <td style={{ width: '15px', padding: '4px' }}>{student.rollNo}</td>
        {allDates.map((date, index) => (
        <td
  key={index}
  style={{
    width: '50px',
    padding: '4px',
    backgroundColor: 
      student.attendance[date]?.present === 'absent' ? '#f0e6e6ff' :
      student.attendance[date]?.present == null ? 'rgb(239 196 0 / 20%)' : 
      'transparent',
  }}
>
  {student.attendance[date]?.present === 'present' ? 'P' :
   student.attendance[date]?.present === 'absent' ? '' :
   ''}  {/* ← Empty string = blank cell */}
</td>

        ))}
       <td style={{ padding: '4px' }}>
  {totalPresent > 0 ? totalPresent : ''}
</td>
        <td style={{ padding: '4px' }}></td>

      </tr>
    );
  })}
</tbody>

</table>
</div>
 {/* <div className='prevnextbtn'>
      <button
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>
      <button style={{marginLeft:'10px'}}
        onClick={() => {
          if (currentPage === Math.ceil(attendanceData.length / studentsPerPage)) {
            setCurrentReportIndex(currentReportIndex + 1);
          } else {
            setCurrentPage(currentPage + 1);
          }
        }}
        disabled={currentPage === Math.ceil(attendanceData.length / studentsPerPage)}
      >
        Next
      </button>
    </div> */}

<div style={{marginBottom:'50px'}}></div>

<div
  style={{
    width: '209mm',
    height: '301mm',
    margin: 'auto',
    padding: '5mm',
    boxSizing: 'border-box',
    border: '1px solid #000',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    color: '#000',
  }}
>

<div style={{ textAlign: 'center', marginBottom: '10px', fontSize: '18px', fontWeight: 'bold' }}>
  {language === "English" ? "Fee, Attendance, and Study Monthly Report - Month: " : "फी, उपस्थिती, अभ्यास इत्यादीचे मासिक पत्रक - महिना : "} {month}
</div>
<div style={{ textAlign: 'center', marginBottom: '20px', fontSize: '16px' }}>
  <span>{language === "English" ? "Note: " : "सूचना: "}</span>{language === "English" ? "All records on this report should be correct and accurate." : "या पत्रकावरील सर्व नोंदी योग्य प्रकारे आणि अचूक कराव्यात."}
</div>
<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
  <span>{language === "English" ? "Class Teacher Name: " : "वर्गशिक्षकाचे नाव :- "} _ _ _ _ _ _ _ _ _ _ _  </span>
  <span>{language === "English" ? "Class: " : "वर्ग :- "} {classValue}</span>
  <span>{language === "English" ? "Division: " : "तुकडी :- "} {divisionValue}</span>
</div>

<table className="table table-bordered" style={{ width: "100%", fontSize: "14px", textAlign: "center", borderCollapse: "collapse" }}>
  <thead>
    <tr>
      <th style={{ width: "50%", padding: "10px", fontWeight: "bold" }}>
        {language === "English" ? "Subject" : "विषय"}
      </th>
      <th style={{ width: "50%", padding: "10px", fontWeight: "bold" }}>
        {language === "English" ? "Teaching Topic" : "अध्यक्षण मुद्दा"}
      </th>
    </tr>
  </thead>
  <tbody>
    {Array(15) 
      .fill(null)
      .map((_, index) => (
        <tr key={index}>
          <td style={{ border: "1px solid black", padding: "15px" }}></td>
          <td style={{ border: "1px solid black", padding: "15px" }}></td>
        </tr>
      ))}
  </tbody>
</table>


  <table
  className="table table-bordered"
  style={{ fontSize: '10px', marginBottom: '10px', marginTop: '5px',padding:'2px' }}
>
 <thead>
    <tr>
      <th style={{ color: 'black', textAlign: 'center' }}>
        {language === "English" ? "Category" : "वर्ग"}
      </th>
      <th style={{ color: 'black', textAlign: 'center' }}>
        {language === "English" ? "Count" : "संख्या"}
      </th>
      {paginatedCastes.map((caste, index) => (
        <th key={index} style={{ color: 'black', textAlign: 'center' }}>
          {caste}
        </th>
      ))}
    </tr>
    <tr>
      <td style={{ color: 'black', textAlign: 'center' }}>
        {language === "English" ? "Total Students" : "एकूण विद्यार्थी"}
      </td>
      <td style={{ color: 'black', textAlign: 'center' }}>{totalStudents}</td>
      {paginatedCastes.map((caste, index) => (
        <td key={index} style={{ textAlign: 'center' }}>
          {(casteCounts[caste] && casteCounts[caste].boys + casteCounts[caste].girls) || 0}
        </td>
      ))}
    </tr>
    <tr>
      <td style={{ textAlign: 'center' }}>
        {language === "English" ? "Boys" : "मुले"}
      </td>
      <td style={{ textAlign: 'center' }}>{totalBoys}</td>
      {paginatedCastes.map((caste, index) => (
        <td key={index} style={{ textAlign: 'center' }}>
          {(casteCounts[caste] && casteCounts[caste].boys) || 0}
        </td>
      ))}
    </tr>
    <tr>
      <td style={{ textAlign: 'center' }}>
        {language === "English" ? "Girls" : "मुली"}
      </td>
      <td style={{ textAlign: 'center' }}>{totalGirls}</td>
      {paginatedCastes.map((caste, index) => (
        <td key={index} style={{ textAlign: 'center' }}>
          {(casteCounts[caste] && casteCounts[caste].girls) || 0}
        </td>
      ))}
    </tr>
  </thead>
  <tbody>
  </tbody>
</table>
</div>

<div className='prevnextbtn' style={{ margin: '20px 0', textAlign: 'center' }}>
  {/* Attendance List Pagination */}
  <div style={{ marginBottom: '10px' }}>
    <span>Attendance List: Page {currentAttendancePage} of {totalAttendancePages}</span>
    <button
      onClick={() => setCurrentAttendancePage(currentAttendancePage - 1)}
      disabled={currentAttendancePage === 1}
      style={{ margin: '0 10px', padding: '5px 10px' }}
    >
      Previous
    </button>
    <button
      onClick={() => setCurrentAttendancePage(currentAttendancePage + 1)}
      disabled={currentAttendancePage === totalAttendancePages}
      style={{ padding: '5px 10px' }}
    >
      Next
    </button>
  </div>

  {/* Caste Report Pagination */}
  {/* <div>
    <span>Caste Report: Page {currentCastePage} of {totalCastePages}</span>
    <button 
      onClick={() => setCurrentCastePage(currentCastePage - 1)}
      disabled={currentCastePage === 1}
      style={{ margin: '0 10px', padding: '5px 10px' }}
    >
      Previous
    </button>
    <button
      onClick={() => setCurrentCastePage(currentCastePage + 1)}
      disabled={currentCastePage === totalCastePages}
      style={{ padding: '5px 10px' }}
    >
      Next
    </button>
  </div> */}



</div>


              </div>
              <div className="text-center">
                <button
                  className="btn btn-success"
                  onClick={handlePrint}
                  style={{ marginTop: '20px', padding: '10px 30px', fontSize: '18px' }}
                >
                  Print Report
                </button>
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  );
}

export default PresentyReport;